import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { makeWorkspaceUrl } from "@/domain/workspace/lib/make-workspace-url";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { ProjectIcon } from "./project-icons";

interface ProjectWorkspaceSidebarNavLinkProps {
  workspace: Workspace;
  forceInactive?: boolean;
}

export const ProjectWorkspaceSidebarNavLink = ({ workspace, forceInactive }: ProjectWorkspaceSidebarNavLinkProps) => {
  const { t } = useDomainTranslation("project");
  return (
    <SidebarNavElement to={makeWorkspaceUrl({ workspace: workspace, path: "projects" })} forceInactive={forceInactive}>
      <ProjectIcon className="mr-2 h-3 w-3" />
      {t("sidebar.navLink")}
    </SidebarNavElement>
  );
};
